module.exports = __webpack_public_path__ + "img/kop_cofid19.1755807f.png";